/* Copyright 2015-2019 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "../form/ToggleButton",
    "../mixins/property/IconMixin",
    "../mixins/property/QuickAccessIconMixin",
    "../mixins/QabWidgetMixin"
], function (declare, ToggleButton, IconMixin, QuickAccessIconMixin, QabWidgetMixin) {

    return declare([ToggleButton, IconMixin, QuickAccessIconMixin, QabWidgetMixin], {
        _qeSetChecked: function(check) {
            this.set("checked", check, true);
        }
    });
});